<template>
  <BCard>
    <div class="text-[#333333] text-[20px] font-semibold">
      Pengajuan Whitelisted
    </div>
    <div class="flex justify-end items-center overflow-x-auto">
      <div class="flex items-center gap-5">
        <div
          class="flex items-center !w-[300px] rounded-[8px] gap-[5px] px-[8px] border-[1px] border-[#E2E2E2] h-[40px]"
        >
          <span
            class="k-search-normal-1 font-bold align-middle"
            style="font-size: 20px"
          />
          <BFormInput
            v-model="search"
            placeholder="Cari nama atau email partner"
            class="border-0 grow"
            @input="searchData"
          />
        </div>
        <div class="flex items-center flex-row">
          <BButton
            id="filter"
            size="sm"
            variant="primary"
            class="position-relative"
            @click="set => (dropdownFilter = !dropdownFilter)"
          >
            <img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
              alt="Komerce"
              width="20"
            >
            <span
              v-if="activeFilterCount > 0"
              class="bg-[#F95031] -top-4 badge position-absolute start-100 translate-middle rounded-pill"
            >
              <span class="text-white font-semibold">{{
                activeFilterCount
              }}</span>
            </span>
          </BButton>
          <ul
            v-if="dropdownFilter"
            class="d-block position-absolute bg-[#f9f9f9] right-[10px] top-[100px] z-10 text-black font-medium text-[12px] pb-1 rounded-xl"
          >
            <div class="text-black pl-2 py-1 text-[16px] border rounded-t-xl">
              Filter
            </div>
            <!-- Filter Tanggal -->
            <div class="hover:bg-[#FCD4BE]">
              <date-range-picker
                ref="picker"
                v-model="dateRange"
                :locale-data="locale"
                :ranges="ranges"
                :opens="'left'"
                :max-date="new Date()"
                class="w-100"
                control-container-class="border-0"
              >
                <template v-slot:input>
                  <div class="d-flex btn">
                    <span>Tanggal</span>
                    <div
                      v-if="dateRange.startDate && dateRange.endDate"
                      class="text-primary ml-[5px]"
                    >
                      (1)
                    </div>
                  </div>
                </template>
              </date-range-picker>
            </div>
            <!-- Filter Status -->
            <div class="hover:bg-[#FCD4BE]">
              <div
                id="popoverStatusFilter"
                class="btn d-flex w-100"
                role="button"
                tabindex="0"
              >
                <span>Status</span>
                <div
                  v-if="statusFilter !== null"
                  class="text-primary ml-[5px]"
                >
                  (1)
                </div>
              </div>
              <b-popover
                target="popoverStatusFilter"
                triggers="focus"
                placement="left"
              >
                <div
                  v-for="(item, index) in statusOptions"
                  :key="index"
                >
                  <b-form-radio
                    v-model="statusFilter"
                    :value="item.value"
                    class="custom-control-primary mb-1"
                    name="status-radio"
                  >
                    <span class="text-black">
                      {{ item.text }}
                    </span>
                  </b-form-radio>
                </div>
              </b-popover>
            </div>
            <!-- Tombol Filter -->
            <div class="border-t-2 pt-1 justify-between d-flex gap-4 px-1">
              <b-button
                variant="outline-primary"
                class="w-40 rounded-lg"
                @click="resetFilter"
              >
                Reset Filter
              </b-button>
              <b-button
                type="submit"
                variant="primary"
                class="w-40 rounded-lg"
                @click="fetchData"
              >
                Terapkan
              </b-button>
            </div>
          </ul>
        </div>
      </div>
    </div>
    <div class="mt-[16px]">
      <BOverlay
        :show="loadingTable"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity=".5"
        rounded="sm"
      >
        <div
          id="table"
          class="mt-1"
          :class="items.length > 20 && 'scrolled-table'"
          @scroll="handleScroll"
        >
          <BTable
            :items="items"
            :fields="fields"
            show-empty
            empty-text="Tidak ada data yang ditampilkan"
            responsive
            class="rounded-lg border border-solid"
          >
            <!-- Column No -->
            <template #cell(no)="data">
              <div class="text-[#333333]">
                {{ data.index + 1 }}
              </div>
            </template>

            <!-- Column Tanggal -->
            <template #cell(tanggal)="data">
              <div class="text-[#333333] flex flex-col">
                <span>{{ newLineSplitDateTime(data.item.created_at)[0] }}</span>
                <span class="text-[#737373] text-sm">{{ newLineSplitDateTime(data.item.created_at)[1] }} WIB</span>
              </div>
            </template>

            <!-- Column Partner -->
            <template #cell(partner)="data">
              <div class="flex flex-col">
                <span class="text-[#333333]">
                  {{ data.item.fullname }}
                </span>
                <span class="text-[#828282] text-sm">{{ data.item.email }}</span>
              </div>
            </template>

            <!-- Column Platform -->
            <template #cell(platform)="data">
              <div class="flex items-center">
                <div
                  v-if="data.item.platform_name === 'google'"
                  class="flex items-center gap-2"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/komads-meta/google.svg"
                    alt="Google"
                    width="20"
                  >
                  <span class="text-[#333333]">Google</span>
                </div>
                <div
                  v-else-if="data.item.platform_name === 'meta'"
                  class="flex items-center gap-2"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/komads-meta/meta.svg"
                    alt="Meta"
                    width="20"
                  >
                  <img
                    v-if="data.item.ad_account_type === 'cpas' && (data.item.marketplace === 'shopee' || data.item.marketplace === '')"
                    src="https://storage.googleapis.com/komerce/komads-meta/shopee.svg"
                    alt="CPAS"
                    width="20"
                  >
                  <img
                    v-if="data.item.ad_account_type === 'cpas' && data.item.marketplace === 'tokopedia'"
                    src="https://storage.googleapis.com/komerce/komads-meta/tokopedia-mascot.png"
                    alt="CPAS"
                    width="20"
                  >
                  <span class="text-[#333333] me-[4px]">Meta</span>
                  <span
                    v-if="data.item.ad_account_type === 'cpas'"
                    class="text-[#333333]"
                  >CPAS</span>
                </div>
                <div
                  v-else-if="data.item.platform_name === 'tiktok'"
                  class="flex items-center gap-2"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/komads-meta/tiktok.svg"
                    alt="TikTok"
                    width="20"
                  >
                  <span class="text-[#333333]">TikTok</span>
                </div>
                <div
                  v-else
                  class="text-[#333333]"
                >
                  {{ data.item.platform_name }}
                </div>
              </div>
            </template>

            <!-- Column Status -->
            <template #cell(status)="data">
              <span
                class="px-[8px] py-[4px] rounded-xl text-center capitalize text-sm w-[90px] inline-block"
                :class="getStatusClass(data.item.status)"
              >
                {{ getStatusText(data.item.status) }}
              </span>
            </template>

            <!-- Column Action -->
            <template #cell(action)="data">
              <BButton
                variant="link"
                class="p-0"
                @click="viewDetail(data.item.id, data.item.platform_name)"
              >
                Detail
              </BButton>
            </template>
          </BTable>
        </div>
      </BOverlay>
    </div>
  </BCard>
</template>

<script>
import { FULL_DATE_TIME, YEAR_MONTH_DAY } from '@/libs/filterDate'
import { newAxiosIns } from '@/libs/axios'
import {
  firstDateOfMonth,
  last7,
  today,
  yesterday,
} from '@/store/helpers'
import DateRangePicker from 'vue2-daterange-picker'
import columnConfig from './config'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  components: {
    DateRangePicker,
  },
  data() {
    return {
      FULL_DATE_TIME,
      fields: columnConfig,
      loadingTable: false,
      lastData: false,
      limit: 25,
      offset: 0,
      items: [],

      // Filter states
      search: null,
      statusFilter: null,
      statusOptions: [
        { value: null, text: 'Semua' },
        { value: 'aktif', text: 'Aktif' },
        { value: 'review', text: 'Review' },
        { value: 'cpas', text: 'On Process CPAS' },
        { value: 'tolak', text: 'Rejected' },
      ],
      dropdownFilter: false,

      // Date range picker
      today,
      yesterday,
      last7,
      firstDateOfMonth,
      dateRange: {
        startDate: undefined,
        endDate: undefined,
      },
      locale: {
        format: 'dd/mm/yyyy',
        applyLabel: 'Terapkan',
        cancelLabel: 'Batal',
        customRangeLabel: 'Custom Range',
      },
      ranges: {
        'Hari ini': [today, today],
        Kemarin: [yesterday, yesterday],
        '7 Hari Terakhir': [last7, today],
        'Bulan ini': [firstDateOfMonth, today],
      },
    }
  },
  computed: {
    activeFilterCount() {
      let count = 0
      if (this.statusFilter !== null) count += 1
      if (this.dateRange.startDate && this.dateRange.endDate) count += 1
      return count
    },
  },
  mounted() {
    this.getListData()
  },
  methods: {
    /**
     * Split date and time into an array with two elements: [date, time]
    */
    newLineSplitDateTime(stringDateTime) {
      return FULL_DATE_TIME(stringDateTime).split(' - ')
    },
    /**
     * Get list data from API
     */
    async getListData() {
      this.loadingTable = true

      const params = {
        limit: this.limit,
        offset: this.offset,
        keyword: this.search,
        status: this.statusFilter,
        start_date: this.dateRange.startDate
          ? YEAR_MONTH_DAY(this.dateRange.startDate)
          : null,
        end_date: this.dateRange.endDate
          ? YEAR_MONTH_DAY(this.dateRange.endDate)
          : null,
      }

      await newAxiosIns
        .get('komads/api/v1/admin/whitelist_account_requests/list', { params })
        .then(res => {
          const { data } = res.data
          this.items = data
          this.offset += data.length
          if (data.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
          this.loadingTable = false
        })
        .catch(err => {
          this.loadingTable = false
          this.items = []
        })

      // Temporarily set loading to false for mock data
      setTimeout(() => {
        this.loadingTable = false
      }, 500)
    },

    /**
     * Handle infinite scroll
     */
    handleScroll(event) {
      const table = event.target || document.getElementById('table')
      if (
        table.scrollTop >= table.scrollHeight - table.offsetHeight - 20
        && !this.loadingTable
        && !this.lastData
      ) {
        this.getNextData()
      }
      if (table.scrollTop === 0) {
        setTimeout(() => {
          table.scrollTop = 1
          setTimeout(() => {
            table.scrollTop = 0
          }, 10)
        }, 10)
      }
    },

    /**
     * Get next page of data
     */
    getNextData() {
      if (!this.lastData) {
        this.loadingTable = true
        const params = {
          limit: this.limit,
          offset: this.offset,
          keyword: this.search,
          status: this.statusFilter,
          start_date: this.dateRange.startDate
            ? YEAR_MONTH_DAY(this.dateRange.startDate)
            : null,
          end_date: this.dateRange.endDate
            ? YEAR_MONTH_DAY(this.dateRange.endDate)
            : null,
        }

        newAxiosIns
          .get('komads/api/v1/admin/whitelist_account_requests/list', { params })
          .then(res => {
            const { data } = res.data
            this.items.push(...data)
            this.offset += data.length
            if (data.length < this.limit) {
              this.lastData = true
            }
          })
          .finally(() => {
            this.loadingTable = false
          })

        setTimeout(() => {
          this.loadingTable = false
        }, 500)
      }
    },

    /**
     * Handle search with debounce
     */
    searchData: _.debounce(function search() {
      this.offset = 0
      this.lastData = false
      this.getListData()
    }, 1000),

    /**
     * Reset all filters
     */
    resetFilter() {
      this.dateRange = {
        startDate: undefined,
        endDate: undefined,
      }
      this.search = null
      this.statusFilter = null
      this.offset = 0
      this.lastData = false
      this.fetchData()
    },

    /**
     * Apply filters and fetch data
     */
    fetchData() {
      this.offset = 0
      this.lastData = false
      this.getListData()
      this.dropdownFilter = false
    },

    /**
     * Get status class for badge
     */
    getStatusClass(status) {
      const variants = {
        accepted: 'bg-[#E6F6EB] text-[#30A46C]',
        'on review': 'bg-[#FFD19A] text-[#CC4E00]',
        rejected: 'bg-[#FEEBEC] text-[#E5484D]',
        'on process cpas': 'bg-[#E6F4FE] text-[#0090FF]',
      }

      return variants[status] || 'bg-gray-100 text-[#828282]'
    },

    /**
     * Get display text for status
     */
    getStatusText(status) {
      const variants = {
        accepted: 'Accepted',
        'on review': 'Review',
        rejected: 'Rejected',
        'on process cpas': 'CPAS',
      }
      return variants[status] || status
    },

    /**
     * View detail of the selected item
     */
    viewDetail(id, platform) {
      this.$router.push(`/komads/setup-whitelisted?id=${id}&platform=${platform}`)
    },
  },
}
</script>

<style scoped>
.scrolled-table {
  height: calc(100vh - 250px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
  will-change: transform;
  transform: translateZ(0);
  backface-visibility: hidden;
}

.scrolled-table .table {
  position: relative;
  border-collapse: separate;
  width: 100%;
  table-layout: fixed;
  margin-bottom: 0;
}

/* Memastikan header tabel tetap terlihat dengan baik */
.scrolled-table .table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white;
}

/* Memastikan baris tabel memiliki tinggi yang cukup */
.scrolled-table .table tbody tr {
  min-height: 50px;
}

.bg-\[\#7AD0FF\] {
  background-color: #7AD0FF;
}

.text-\[\#0F679A\] {
  color: #0F679A;
}
</style>
